function WidgetDescription({text, style = {}}) {
  return <label className="co-text" style={{ letterSpacing: '1px', fontSize: '16px', textAlign: 'center', ...style }}>{text || ''}</label>
}

export default WidgetDescription;